import { render, staticRenderFns } from "./PublishProductsModal.vue?vue&type=template&id=6220e847&"
import script from "./PublishProductsModal.vue?vue&type=script&lang=js&"
export * from "./PublishProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports